import React from 'react'
import './404.css'
import withLayout from '../../withLayout'

const NotFound = (props) => (
  <div className='error404'>
    <div>
      <h1>404</h1>
      <p>La página a la que estás intentando acceder no se encuentra.<br />Asegúrate que la <b>url</b> esté correcta.</p>
    </div>
  </div>
)

export default withLayout(NotFound, null)
